import { Box } from "@mui/material";

import { polymarketEmbedSrc } from "../data/polymarket";

const EMBED_HEIGHT = 300;

interface PolymarketEmbedProps {
  name?: string;
  slug?: string;
}

export function PolymarketEmbed({
  name,
  slug,
}: PolymarketEmbedProps): JSX.Element | null {
  const src = polymarketEmbedSrc(slug, EMBED_HEIGHT);
  if (!src) return null;

  return (
    <Box sx={{ maxWidth: 420, width: "100%" }}>
      <iframe
        title={`${name ?? "Market"} — Polymarket prediction market`}
        src={src}
        height={EMBED_HEIGHT}
        loading="lazy"
        style={{ border: 0, width: "100%" }}
      />
    </Box>
  );
}
